import { Component } from '@angular/core';

@Component({
    selector: 'vw-check-icon',
    imports: [],
    template: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`
})
export class CheckIconComponent {

}
